import api from '@/api';
import {
  CompanyAvailabilityCreateRequest,
  CompanyAvailabilityEditRequest,
  CompanyAvailabilityListRequest,
  CompanyAvailabilityListResponse,
} from './company-availability.types';

const path = '/enterprise/v1/company-availabilities';

export default {
  async list(params: CompanyAvailabilityListRequest) {
    const result = (await api.get(path, params)) as unknown;
    return (result as CompanyAvailabilityListResponse).data;
  },

  async create(data: CompanyAvailabilityCreateRequest) {
    const result = (await api.post(path, data)) as unknown;
    return result as void;
  },

  async delete(id: number) {
    const result = (await api.remove(`${path}/${id}`, {}, null)) as unknown;
    return result as void;
  },

  async edit({ id, ...data }: CompanyAvailabilityEditRequest) {
    const result = (await api.put(`${path}/${id}`, data, null)) as unknown;
    return result as void;
  },
};
